import merge from 'deepmerge'
import AfipCrudRoutes from './AfipCrudRoutes'
import AfipRoutes from './AfipRoutes'

const routes = merge.all([AfipCrudRoutes,AfipRoutes])


export default routes;

